import { render } from "./PersonLookupComponent.vue?vue&type=template&id=001e882b"
import script from "./PersonLookupComponent.vue?vue&type=script&lang=js"
export * from "./PersonLookupComponent.vue?vue&type=script&lang=js"

import "./PersonLookupComponent.vue?vue&type=style&index=0&id=001e882b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__